export default function makeCancelable(promise) {
  let isCanceled = false;
  
  const wrappedPromise = new Promise((resolve, reject) => {
    promise
      .then(val => (isCanceled ? console.log("cancelled") : resolve(val)))
      .catch(error => (isCanceled ? console.log("cancelled") : reject(error)));
  });
  
  return {
    promise: wrappedPromise,
    cancel() {
      isCanceled = true;
    },
  };
}


// WEBPACK FOOTER //
// ./app/api/cancelable.js